import * as tslib_1 from "tslib";
import { GroupSummaryDisplayMode_$type } from "./GroupSummaryDisplayMode";
import { IgrCellInfo } from "./igr-cell-info";
import { SectionHeaderCellModel as SectionHeaderCellModel_internal } from "./SectionHeaderCellModel";
import { ensureEnum } from "igniteui-react-core";
/**
 * Backing information for a section header cell in the grid.
*/
var IgrSectionHeaderCellInfo = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrSectionHeaderCellInfo, _super);
    function IgrSectionHeaderCellInfo() {
        return _super.call(this) || this;
    }
    IgrSectionHeaderCellInfo.prototype.createImplementation = function () {
        return new SectionHeaderCellModel_internal();
    };
    Object.defineProperty(IgrSectionHeaderCellInfo.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrSectionHeaderCellInfo.prototype, "resolvedText", {
        /**
         * Sets or gets the resolved text for the section header cell.
        */
        get: function () {
            return this.i.kv;
        },
        set: function (v) {
            this.i.kv = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrSectionHeaderCellInfo.prototype, "resolvedSummaryText", {
        /**
         * Sets or gets the resolved summary text for the section header cell.
        */
        get: function () {
            return this.i.kt;
        },
        set: function (v) {
            this.i.kt = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrSectionHeaderCellInfo.prototype, "summaryDisplayMode", {
        /**
         * Sets or gets how summaries are displayed in the section header cell.
        */
        get: function () {
            return this.i.kk;
        },
        set: function (v) {
            this.i.kk = ensureEnum(GroupSummaryDisplayMode_$type, v);
        },
        enumerable: true,
        configurable: true
    });
    return IgrSectionHeaderCellInfo;
}(IgrCellInfo));
export { IgrSectionHeaderCellInfo };
//# sourceMappingURL=igr-section-header-cell-info.js.map
